// import eu from './eu-EU'
// import en from './en-US'
// import ar from './ar'
// import pt from './pt-PT'
// import es from './es-ES'
// import hi from './hi-HI'
import English from './en-US';
import Hindi from './hi-HI';
import German from './ar';
import French from './es-ES';
import Spanish from './eu-EU';
import Portuguese from './pt-PT';




const translations = {
  English,
  Hindi,
  German,
  French,
  Portuguese,
  Spanish
};

const getTrans = (
  key,
  locale = JSON.parse(localStorage.getItem('LanguageKey') || '{}')//window.translateTo
) => {
  const currTranslation = translations[locale] ? translations[locale] : English;
  let transWord = currTranslation[key]
    ? currTranslation[key]
    : English[key]
    ? English[key]
    : key;
  return transWord;
};

export { getTrans };